export enum CHECK_EMAIL_SEARCH_TYPE {
    PASSWORD = 'password',
    REGISTER = 'register',
}
